module.exports = __webpack_public_path__ + "img/info_cohorts.27a95a68.png";